export default {
  OK: 'OK',
  NETWORK_ERROR: 'Network Error',
  UNAUTHORIZED: 'Unauthorized',
  CANCELED: 'Canceled'
};
